<template>
<div>
  <div class="page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h4>{{ $t('new_item') }}</h4>
      </div>
    </div>

    <ul class="table-top-head">
      <!-- Stock toggle -->
      <li class="d-flex align-items-center gap-2">
        <label class="form-check-label fw-bold mb-0" style="font-size: 1.125rem;">
          {{ $t('item_with_stock') }}
        </label>

        <div class="form-check form-switch mb-0 d-flex align-items-center">
          <input
            class="form-check-input me-2"
            type="checkbox"
            id="stockToggle"
            v-model="items.with_stock"
            role="switch"
          />
          <label class="form-check-label mb-0" style="font-size: 1.125rem; min-width: 40px;" for="stockToggle">
            {{ items.with_stock ? $t('Yes') : $t('No') }}
          </label>
        </div>
      </li>
      <li>
        <div class="page-btn">
          <router-link to="/items" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
      <li>
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
      </li>
    </ul>
  </div>

  <!-- /add -->
  <form @submit.prevent="submitItem" @keydown.enter="handleEnter" enctype="multipart/form-data">
    <div class="card">
      <div class="card-body add-product pb-0">
        <div class="accordion-card-one accordion" id="accordionExample">
          <div class="accordion-item">
            <div class="accordion-header" id="headingOne">
              <div class="accordion-button" >
                <div class="addproduct-icon" >
                  <h5><i class="ti ti-info-circle"></i><span>{{ $t('item_information') }}</span></h5>
<!--                  <a href="javascript:void(0);"><i class="ti ti-chevron-down"></i></a>-->
                </div>
              </div>
            </div>
            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('item_code') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.item_code"
                        class="form-control"
                        @input="clearError('item_code')"
                      />
                      <div v-if="errors.item_code" class="text-danger mt-2">
                        <span>{{ errors.item_code }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('sku') }}
                      </label>
                      <input
                        type="text"
                        v-model="items.sku"
                        class="form-control"
                        @input="clearError('sku')"
                      />
                      <div v-if="errors.sku" class="text-danger mt-2">
                        <span>{{ errors.sku }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('item_name') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.item_name"
                        class="form-control"
                        @input="clearError('item_name')"
                      />
                      <div v-if="errors.item_name" class="text-danger mt-2">
                        <span>{{ errors.item_name }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('category') }} <span class="text-danger">*</span> </label>
                        <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#create-modal2"><i class="ti ti-circle-plus me-1" ></i><span>{{ $t("add_new") }}</span></a>
                      </div>
                      <VueSelect2
                        v-model="items.category"
                        :options="formattedCategories"
                        :settings="{
                          placeholder: $t('select_an_option'),
                          allowClear: true,
                        }"
                        @select="handleCategorySelect"
                        class="form-control"
                      />
                      <div v-if="errors.category" class="text-danger">{{ errors.category }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="mb-3 add-product">
                        <div class="add-newplus">
                          <label class="form-label">{{ $t('sub_category') }} <span class="text-danger">*</span></label>
                          <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal3" @click="triggerFetchCategoryDetails"><i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span></a>
                        </div>
                        <VueSelect2
                          v-model="items.sub_category"
                          :options="formattedsub_categories"
                          :settings="{
                            placeholder: $t('select_an_option'),
                            allowClear: true,
                          }"
                          @select="(value) => handleSelect2Change('sub_category', value)"
                          @change="onChange"
                          class="form-control"
                        />
                        <div v-if="errors.sub_category" class="text-danger">{{ errors.sub_category }}</div>
                      </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="mb-3 add-product">
                        <div class="add-newplus">
                          <label class="form-label">{{ $t('size') }} <span class="text-danger">*</span></label>
                          <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal4"><i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span></a>
                        </div>
                        <VueSelect2
                          v-model="items.size"
                          :options="formattedsizes"
                          :settings="{
                            placeholder: $t('select_an_option'),
                            allowClear: true,
                          }"
                          @select="(value) => handleSelect2Change('size', value)"
                          @change="onChange"
                          class="form-control"
                        />
                        <div v-if="errors.size" class="text-danger">{{ errors.size }}</div>
                      </div>
                    </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('color') }} <span class="text-danger">*</span></label>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal5"><i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span></a>
                      </div>
                      <VueSelect2
                        v-model="items.color"
                        :options="formattedcolors"
                        :settings="{
                          placeholder: $t('select_an_option'),
                          allowClear: true,
                        }"
                        @select="(value) => handleSelect2Change('color', value)"
                        @change="onChange"
                        class="form-control"
                      />
                      <div v-if="errors.color" class="text-danger">{{ errors.color }}</div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="mb-3 add-product">
                        <label class="form-label">
                          {{ $t('model_number') }}
                        </label>
                        <input
                          type="text"
                          v-model="items.model_number"
                          class="form-control"
                        />
                        <div v-if="errors.model_number" class="text-danger">{{ errors.model_number }}</div>
                      </div>
                    </div>

                </div>

                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('unit') }} <span class="text-danger">*</span></label>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal6"><i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span></a>
                      </div>
                      <VueSelect2
                        v-model="items.unit"
                        :options="formattedunits"
                        :settings="{
                          placeholder: $t('select_an_option'),
                          allowClear: true,
                        }"
                        @select="(value) => handleSelect2Change('unit', value)"
                        @change="onChange"
                        class="form-control"
                      />
                      <div v-if="errors.unit" class="text-danger">{{ errors.unit }}</div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('reorder_level') }}
                      </label>
                      <input
                        type="text"
                        v-model="items.reorder_level"
                        class="form-control"
                      />
                      <div v-if="errors.reorder_level" class="text-danger">{{ errors.reorder_level }}</div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('barcode_qr_code') }}
                      </label>
                      <input
                        type="text"
                        v-model="items.barcode_qr_code"
                        class="form-control"
                      />
                      <div v-if="errors.barcode_qr_code" class="text-danger">{{ errors.barcode_qr_code }}</div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <label class="form-label">{{ $t('selling_price') }} <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="items.selling_price"
                      class="form-control"
                      @input="clearError('selling_price')"
                    />
                    <div v-if="errors.selling_price" class="text-danger mt-2">
                      <span>{{ errors.selling_price }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <label class="form-label">{{ $t('discount') }}</label>
                    <input
                      type="text"
                      v-model="items.discount"
                      class="form-control"
                    />
                    <div v-if="errors.discount" class="text-danger mt-2">
                      <span>{{ errors.discount }}</span>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <label class="form-label">{{ $t('vat_group') }} <span class="text-danger">*</span></label>
                    <VueSelect2
                      v-model="items.vat_group"
                      :options="formattedvats"
                      :settings="{
                        placeholder: $t('select_an_option'),
                        allowClear: true,
                      }"
                      @select="(value) => handleSelect2Change('vat_group', value)"
                      @change="onChange"
                      class="form-control"
                    />
                    <div v-if="errors.vat_group" class="text-danger">{{ errors.vat_group }}</div>
                  </div>

                  <div v-if="items.with_stock" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('warehouse') }} <span class="text-danger">*</span></label>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal1" @click="openModal"><i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span></a>
                      </div>
                      <VueSelect2
                        v-model="items.warehouse"
                        :options="formattedwarehouses"
                        :settings="{
                          placeholder: $t('select_an_option'),
                          allowClear: true,
                        }"
                        @select="(value) => handleSelect2Change('warehouse', value)"
                        @change="onChange"
                        class="form-control"
                      />
                      <div v-if="errors.warehouse" class="text-danger">{{ errors.warehouse }}</div>
                    </div>
                  </div>

                  <div v-if="items.with_stock" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <label class="form-label">{{ $t('stock_quantity') }} <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="items.stock_quantity"
                      class="form-control"
                      @input="clearError('stock_quantity')"
                    />
                    <div v-if="errors.stock_quantity" class="text-danger mt-2">
                      <span>{{ errors.stock_quantity }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div v-if="items.with_stock" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 position-relative">
                      <label class="form-label fw-semibold">{{ $t('manufacturing_date') }}</label>
                      <div class="input-group">
                        <span class="input-group-text bg-white border-end-0">
                          <i class="ti ti-calendar text-secondary"></i>
                        </span>
                        <input
                          type="date"
                          v-model="items.manufacturing_date"
                          :format="'yyyy-MM-dd'"
                          class="form-control border-start-0"
                          @input="clearError('manufacturing_date')"
                        />
                      </div>
                      <div v-if="errors.manufacturing_date" class="text-danger mt-1 small">
                        <span>{{ errors.manufacturing_date }}</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="items.with_stock" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 position-relative">
                      <label class="form-label fw-semibold">{{ $t('expire_date') }}</label>
                      <div class="input-group">
                        <span class="input-group-text bg-white border-end-0">
                          <i class="ti ti-calendar text-secondary"></i>
                        </span>
                        <input
                          type="date"
                          v-model="items.expire_date"
                          :format="'yyyy-MM-dd'"
                          class="form-control border-start-0"
                          @input="clearError('expire_date')"
                        />
                      </div>
                      <div v-if="errors.expire_date" class="text-danger mt-1 small">
                        <span>{{ errors.expire_date }}</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="items.with_stock" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('supplier_name') }} <span class="text-danger">*</span></label>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal7"><i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span></a>
                      </div>
                      <VueSelect2
                        v-model="items.supplier_name"
                        :options="formattedsuppliers"
                        :settings="{
                          placeholder: $t('select_an_option'),
                          allowClear: true,
                        }"
                        @select="(value) => handleSelect2Change('supplier_name', value)"
                        @change="onChange"
                        class="form-control"
                      />
                      <div v-if="errors.supplier_name" class="text-danger">{{ errors.supplier_name }}</div>
                    </div>
                  </div>

                  <div v-if="items.with_stock" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <label class="form-label">{{ $t('purchase_price') }} <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="items.purchase_price"
                      class="form-control"
                      @input="clearError('purchase_price')"
                    />
                    <div v-if="errors.purchase_price" class="text-danger mt-2">
                      <span>{{ errors.purchase_price }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-card-one accordion" id="accordionExample3">
          <div class="accordion-item">
            <div class="accordion-header" id="headingThree">
              <div class="accordion-button">
                <div class="addproduct-icon list">
                  <h5><i class="ti ti-photo-plus"></i><span>{{ $t('images') }}</span></h5>
<!--                  <a href="javascript:void(0);"><i class="ti ti-chevron-down"></i></a>-->
                </div>
              </div>
            </div>
            <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree" data-bs-parent="#accordionExample3">
              <div class="accordion-body">
                <div class="text-editor add-list add">
                  <div class="col-lg-12">
                    <div class="add-choosen">
                      <div class="input-blocks">
                        <div class="image-upload position-relative" style="width: 220px; height: 120px;">
                          <input
                            type="file"
                            class="form-control d-none"
                            id="imageUploadInput"
                            name="images"
                            @change="imageUpload"
                            accept="image/*"
                            multiple
                          />

                          <!-- Fixed-size upload box -->
                          <label
                            for="imageUploadInput"
                            class="d-flex flex-column align-items-center justify-content-center border border-primary rounded text-primary w-100 h-100"
                            style="cursor: pointer;"
                          >
                            <i class="ti ti-upload fs-1 mb-2"></i>
                            <h4 class="mb-0">{{ $t('add_images') }}</h4>
                          </label>

                          <!-- Error message show under the button -->
                          <div
                            v-if="errors.images"
                            class="text-danger small position-absolute start-0 bottom-n1 w-100 text-center"
                            style="transform: translateY(100%);"
                          >
                            {{ errors.images }}
                          </div>
                        </div>
                      </div>

                      <div class="phone-img" v-for="(preview, index) in imagePreview" :key="index">
                        <img :src="preview" alt="image">
                        <a href="javascript:void(0);" @click="removeImage(index);"><i class="ti ti-x"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <div class="btn-addproduct mb-4">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
      </div>
    </div>
  </form>

  <!-- /add -->
  <CreateWarehouseModal
    id="create-modal1" @create_success="fetchWarehouse"
  />

  <CreateCategoryModal
    id="create-modal2" @create_success="fetchCategory"
  />

  <CreateSubCategoryModal
    id="create-modal3"
    ref="createSubCategoryModal" 
    :category="items.category"
    @create_success="fetchCatSubCategories"
  />

  <CreateSizeModal
    id="create-modal4" @create_success="fetchSize"
  />

  <CreateColorModal
    id="create-modal5" @create_success="fetchColor"
  />

  <CreateUnitModal
    id="create-modal6" @create_success="fetchUnit"
  />

  <CreateSupplierModal
    id="create-modal7" @create_success="fetchSupplier"
  />
</div>
</template>

<script>
import Modal from "@/components/common/Modal.vue"; // Import Modal component
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import VueSelect2 from "vue3-select2-component";
import CreateWarehouseModal from "@/views/admin_dashboard/item/CreateWarehouseModal.vue";
import CreateCategoryModal from "@/views/admin_dashboard/item/CreateCategoryModal.vue";
import CreateSubCategoryModal from "@/views/admin_dashboard/item/CreateSubCategoryModal.vue";
import CreateSizeModal from "@/views/admin_dashboard/item/CreateSizeModal.vue";
import CreateColorModal from "@/views/admin_dashboard/item/CreateColorModal.vue";
import CreateUnitModal from "@/views/admin_dashboard/item/CreateUnitModal.vue";
import CreateSupplierModal from "@/views/admin_dashboard/item/CreateSupplierModal.vue";
import {useToast} from "vue-toastification";

export default {
  components: {
    CreateCategoryModal,
    Modal,
    Vue3Datepicker,
    VueSelect2,
    CreateWarehouseModal,
    CreateSubCategoryModal,
    CreateSizeModal,
    CreateColorModal,
    CreateUnitModal,
    CreateSupplierModal
  },

  emits: ['select'],

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      items: {
        with_stock: false, item_code: '', item_name: '', sku: '', category: null, sub_category: null, size: null, color: null, model_number: '',
        warehouse: null, stock_quantity: '', unit: null, reorder_level: 0, manufacturing_date: null, expire_date: null,
        item_serial_number: '', barcode_qr_code: '', supplier_name: null, purchase_price: '', selling_price: '', discount: 0, vat_group: 0, images: [],

      },
      categories: [],
      sub_categories: [],
      sizes: [],
      colors: [],
      warehouses: [],
      units: [],
      suppliers: [],
      errors: {},
      errorMessage: "",
      selected_cats_sub_categories: [],
      imagePreview: [],
      vat_groups: [],
    };
  },

  mounted() {
    this.fetchDropdownData();
  },

  computed: {
    formattedCategories() {
      return this.categories.map(cat => ({ id: cat.id, text: cat.node }));
    },

    formattedsub_categories() {
      return this.selected_cats_sub_categories.map(sub_categorie => ({ id: sub_categorie.id, text: sub_categorie.node }));
    },

    formattedwarehouses() {
      return this.warehouses.map(warehouse => ({ id: warehouse.id, text: warehouse.name }));
    },

    formattedsizes() {
      return this.sizes.map(size => ({ id: size.id, text: size.size }));
    },

    formattedcolors() {
      return this.colors.map(color => ({ id: color.id, text: color.color }));
    },

    formattedunits() {
      return this.units.map(unit => ({ id: unit.id, text: unit.unit }));
    },

    formattedsuppliers() {
      return this.suppliers.map(supplier => ({ id: supplier.id, text: supplier.name }));
    },

    formattedvats() {
      return this.vat_groups.map(group => ({ id: group.id, text: group.vat_group_name }));
    },

  },

  watch: {
    'items.with_stock'(enabled) {
      if (!enabled) {
        this.items.stock_quantity = 0;
        this.items.warehouse = null;
        this.items.manufacturing_date = null;
        this.items.expire_date = null;
        this.items.item_serial_number = null;
        this.items.supplier_name = null;
        this.items.purchase_price = 0;
      }
    }
  },

  methods: {
      async fetchDropdownData() {
        try {
          const [
            categoriesRes, sub_categoriesRes, sizeRes, colorRes,
            warehouseRes, unitRes, supplierRes, vat_groupRes
          ] = await Promise.all([
            this.$axios.get(apiUrls.categories.get),
            this.$axios.get(apiUrls.sub_categories.get),
            this.$axios.get(apiUrls.item_size.get),
            this.$axios.get(apiUrls.item_color.get),
            this.$axios.get(apiUrls.inventory_warehouse.get),
            this.$axios.get(apiUrls.measurement_unit.get),
            this.$axios.get(apiUrls.inventory_supplier.get),
            this.$axios.get(apiUrls.vat_group.get)
          ]);

          this.categories = categoriesRes?.data || [];
          this.sub_categories = sub_categoriesRes?.data || [];
          this.sizes = sizeRes?.data || [];
          this.colors = colorRes?.data || [];
          this.warehouses = warehouseRes?.data || [];
          this.units = unitRes?.data || [];
          this.suppliers = supplierRes?.data || [];
          this.vat_groups = vat_groupRes?.data || [];

        } catch (error) {
          console.error('Error loading dropdown data:', error);
        }
      },

      onChange(value) {
        this.items.category = value;

        // Filter sub-categories based on selected category
        this.$emit('select', value);
      },

      fetchCategory(newCat) {
        this.categories.push(newCat);

        this.$nextTick(() => {
          this.items.category = String(newCat.id);
        });
      },

      fetchWarehouse(newWarehouse) {
        this.warehouses.push(newWarehouse);

        this.$nextTick(() => {
          this.items.warehouse = newWarehouse.id;
        });
      },

      fetchSize(newSize) {
        this.sizes.push(newSize);

        this.$nextTick(() => {
          this.items.size = newSize.id;
        });
      },

      fetchColor(newColor) {
        this.colors.push(newColor);

        this.$nextTick(() => {
          this.items.color = newColor.id;
        });
      },

      fetchUnit(newUnit) {
        this.units.push(newUnit);

        this.$nextTick(() => {
          this.items.unit = newUnit.id;
        });
      },

      fetchSupplier(newSupplier) {
        this.suppliers.push(newSupplier);

        this.$nextTick(() => {
          this.items.supplier_name = newSupplier.id;
        });
      },

      onChangeCategory(selectedValue) {
        this.fetchCatSubCategories(selectedValue.id);
      },

      handleCategorySelect(selectedValue) {
        // clear error
        delete this.errors.category;

        // existing onChange logic
        this.onChangeCategory(selectedValue);
      },

      handleSelect2Change(field, value) {
        // clear error
        delete this.errors[field];

        // set selected value
        this.items[field] = value.id;

        // extra logic for category
        if (field === 'category') {
          this.fetchCatSubCategories(value.id);
        }
      },

      triggerFetchCategoryDetails() {
        // Trigger fetchCategoryDetails in the child component when modal is clicked
        this.$refs.createSubCategoryModal.fetchCategoryDetails(this.items.category);
      },

      async fetchCatSubCategories(categoryACCId,newSubCategory_id = null) {
        try {
          const response = await this.$axios.get(`${apiUrls.sub_categories.get}`, {
            params: { category_id: categoryACCId }  
          });
          this.selected_cats_sub_categories = response.data;
          if (newSubCategory_id) {
            this.items.sub_category = newSubCategory_id;
          }
        } catch (error) {

        }
      },

      imageUpload(event) {
        const files = event.target.files;

        const allowedTypes = [
          'image/jpeg',
          'image/png',
          'image/webp'
        ];

        if (files && files.length > 0) {
          if (this.items.images.length + files.length > 2) {
            this.errors.images = this.$t('error.max_images');
            return;
          }

          for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // frontend validation
            if (!allowedTypes.includes(file.type)) {
              this.errors.images =
                'Only JPG, PNG, and WEBP images are allowed.';
              continue;
            }

            this.errors.images = '';
            this.items.images.push(file);
            this.imagePreview.push(URL.createObjectURL(file));
          }
        }
      },

      removeImage(index) {
        this.items.images.splice(index, 1);
        this.imagePreview.splice(index, 1);
      },

      clearError(field) {
        if (this.errors[field]) {
          delete this.errors[field];
        }
      },

      prepareItemPayload() {
        if (this.items.with_stock) {
          // Convert foreign keys to integer
          ['warehouse', 'supplier_name'].forEach((field) => {
            if (this.items[field]) this.items[field] = Number(this.items[field]);
          });

          // Ensure numeric fields
          this.items.stock_quantity = Number(this.items.stock_quantity);
          this.items.purchase_price = Number(this.items.purchase_price);
        } else {
          // No stock, send safe defaults
          this.items.stock_quantity = 0;
          this.items.warehouse = null;
          this.items.manufacturing_date = null;
          this.items.expire_date = null;
          this.items.item_serial_number = '';
          this.items.supplier_name = null;
          this.items.purchase_price = 0;
        }
      },

      async submitItem() {
        this.prepareItemPayload();
        // Frontend validation before making API call
          this.errors = {};
          if (!this.items.item_code.trim()) this.errors.item_code = this.$t('error.required');
          if (!this.items.item_name.trim()) this.errors.item_name = this.$t('error.required');
          if (!this.items.category) this.errors.category = this.$t('error.required');
          if (!this.items.sub_category) this.errors.sub_category = this.$t('error.required');
          if (!this.items.size) this.errors.size = this.$t('error.required');
          if (!this.items.color) this.errors.color = this.$t('error.required');
          if (!this.items.unit) this.errors.unit = this.$t('error.required');
          if (!this.items.selling_price.trim()) this.errors.selling_price = this.$t('error.required');
          if (this.items.images && this.items.images.length > 2) this.errors.images = this.$t('error.max_images');

          if (this.items.with_stock) {
            if (
              this.items.stock_quantity === null ||
              this.items.stock_quantity === '' ||
              Number(this.items.stock_quantity) <= 0
            ) {
              this.errors.stock_quantity = this.$t('error.required');
            }

            if (!this.items.warehouse) {
              this.errors.warehouse = this.$t('error.required');
            }

            if (!this.items.supplier_name) {
              this.errors.supplier_name = this.$t('error.required');
            }

            if (
              this.items.purchase_price === null ||
              this.items.purchase_price === '' ||
              Number(this.items.purchase_price) <= 0
            ) {
              this.errors.purchase_price = this.$t('error.required');
            }

            if (!this.items.manufacturing_date) {
              this.errors.manufacturing_date = this.$t('error.required');
            }

            if (!this.items.expire_date) {
              this.errors.expire_date = this.$t('error.required');
            }
          }

          if (Object.keys(this.errors).length > 0) {
            return; // Stop execution if validation fails
        }

        try {
          const formData = new FormData();
          Object.keys(this.items).forEach((key) => {
            if (key === 'images' && Array.isArray(this.items.images)) {
              this.items.images.forEach((image) => {
                formData.append('images', image);
              });
            } else {
              formData.append(key, this.items[key]);
            }
          });

          // Send API request
          const response = await this.$axios.post(apiUrls.item.post, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.toast.success("Item Successfully Created!");

          // Redirect only after successful response
          this.$router.push('/items');

          // Emit event to update parent component
          this.$emit("create_success");

          this.resetForm();
        } catch (error) {
            if (error.response?.data) {
            const data = error.response.data;

            // field validation errors
            Object.keys(data).forEach((key) => {
              if (Array.isArray(data[key])) {
                this.errors[key] = data[key][0];
              } else {
                this.errors[key] = data[key];
              }
            });
          }

          // toast for backend/global errors
          if (error.response?.data?.error) {
            this.toast.error(error.response.data.error);
          }

          // duplicate item name toast
          if (error.response?.data?.item_name) {
            this.toast.error(error.response.data.item_name[0]);
          }

          // duplicate item code toast
          if (error.response?.data?.item_code) {
            this.toast.error(error.response.data.item_code[0]);
          }
        }
      },

      cancelForm() {
        this.$router.push('/items');
      },

      resetForm() {
        // Reset form fields and errors
        this.items = {
          item_code: '', item_name: '', sku: '', category: '', sub_category: '', size: '', color: '', model_number: '',
          warehouse: '', stock_quantity: '', unit: '', reorder_level: '', manufacturing_date: '', expire_date: '',
          item_serial_number: '', barcode_qr_code: '', supplier_name: '', purchase_price: '', selling_price: '', discount: '', vat_group: 0, images: ''

        };
        this.errors = {};
        this.errorMessage = "";
      },

      handleEnter(e) {
        // allow enter inside select2
        if (e.target.classList.contains('select2-search__field')) {
          return;
        }

        // allow textarea enter
        if (e.target.tagName.toLowerCase() === 'textarea') {
          return;
        }

        e.preventDefault();
      },

    },

};
</script>
